import { render, staticRenderFns } from "./AdminAccountCard.vue?vue&type=template&id=506cdf5e&scoped=true"
import script from "./AdminAccountCard.vue?vue&type=script&lang=js"
export * from "./AdminAccountCard.vue?vue&type=script&lang=js"
import style0 from "./AdminAccountCard.vue?vue&type=style&index=0&id=506cdf5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506cdf5e",
  null
  
)

export default component.exports